// Helper timezone lato client: formattazione Europe/Rome per frontend-squadra

export function formatRome(iso: string | Date, opts?: Intl.DateTimeFormatOptions): string {
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return '';
  const base: Intl.DateTimeFormatOptions = {
    timeZone: 'Europe/Rome',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  return new Intl.DateTimeFormat('it-IT', { ...base, ...opts }).format(d);
}

// Converte un valore UTC / Date / ISO in formato per input datetime-local (yyyy-MM-ddTHH:mm)
// garantendo rigorosamente il fuso orario di Roma (Europe/Rome - CET/CEST)
export function toRomeDateTimeInput(dateOrIso?: string | Date | null): string {
  if (!dateOrIso) return '';
  const d = dateOrIso instanceof Date ? dateOrIso : new Date(dateOrIso);
  if (isNaN(d.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Rome',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(d);
  const get = (t: string) => parts.find((p) => p.type === t)?.value || '00';
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
}

export function nowLocalInput(): string {
  return toRomeDateTimeInput(new Date());
}

// Converte un input datetime-local (espresso nel fuso orario Europe/Rome) in ISO UTC string
export function localToUtcIso(localValue?: string | null): string {
  if (!localValue) return new Date().toISOString();
  const m = String(localValue).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
  if (!m) return new Date(localValue).toISOString();
  const [, y, mo, d, h, mi] = m;
  const targetUtcMs = Date.UTC(+y, +mo - 1, +d, +h, +mi);
  let guess = new Date(targetUtcMs);
  for (let i = 0; i < 3; i++) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Rome',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(guess);
    const get = (t: string) => parts.find((p) => p.type === t)?.value;
    const currentRomeAsUtcMs = Date.UTC(+get('year')!, +get('month')! - 1, +get('day')!, +get('hour')!, +get('minute')!);
    const diffMs = targetUtcMs - currentRomeAsUtcMs;
    if (diffMs === 0) break;
    guess = new Date(guess.getTime() + diffMs);
  }
  return guess.toISOString();
}

// Restituisce l'identificativo del turno operativo h24 (05:00 -> 05:00) 'YYYY-MM-DD'
// nel fuso Europe/Rome (tra le 00:00 e le 04:59 appartiene al turno iniziato il giorno prima)
export function getTurnoDateStrRome(now: Date | string = new Date()): string {
  const d = now instanceof Date ? now : new Date(now);
  if (isNaN(d.getTime())) return '';
  const romeDateStr = d.toLocaleDateString('en-CA', { timeZone: 'Europe/Rome' });
  const romeHourStr = d.toLocaleTimeString('en-US', { timeZone: 'Europe/Rome', hour: 'numeric', hour12: false });
  const romeHour = parseInt(romeHourStr, 10);
  const base = new Date(`${romeDateStr}T12:00:00.000Z`);
  if (romeHour < 5) {
    base.setUTCDate(base.getUTCDate() - 1);
  }
  return base.toLocaleDateString('en-CA', { timeZone: 'UTC' });
}

